/*
 * @Author: ningbo.kang
 * @Date: 2019-09-29 18:27:44
 * @LastEditors: JikeyChang
 * @LastEditTime: 2022-10-26 11:49:07
 * @FilePath: /template/src/router/index.js
 * @Description: 描述
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
// import routerConfig from '@/config/routes';
// 路由数据
import { routerBeforeEachFunc, routerAfterEachFunc } from '@/config/interceptors/router';
import routes from './routes';

// 路由拦截器

// 3.1.3 NavigationDuplicated
// hack router push callback
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
// 注入默认配置和路由表
const routerInstance = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

// 注入拦截器
routerInstance.beforeEach(routerBeforeEachFunc);
routerInstance.afterEach(routerAfterEachFunc);

export default routerInstance;
